import { FaHome, FaRegEnvelope, FaBars, FaSearch, FaBell, FaTimes } from "react-icons/fa"
import { BiStoreAlt, } from "react-icons/bi"
import { VscOrganization } from "react-icons/vsc"
import { Link } from 'react-router-dom'
import { NavLink } from "react-router-dom"
import profilePic from "../assets/user.png"
import logo from "../assets/onnize.png"
import "./components.css"
import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { clearCredentials } from "../app/slices/authSlice"
import { api } from "../app/Api/ApiSlice"
import { selectAuthPersisted } from "../app/selectors/authSelectors"




const Navbar = () => {
    const [sideMenu, setSideMenu] = useState(false)
    const [loading, setLoading] = useState(false)
    const user = useSelector(selectAuthPersisted)

    // console.log("navbar:",user)

    const dispatch = useDispatch()


    const toogleMenu = () => setSideMenu(!sideMenu)
    const closeMenu = () => setSideMenu(false)

    const handleLogOut = async () => {
        setLoading(true)
        try {
            await api.post("/account/logout");
            setLoading(false)
            dispatch(clearCredentials());
        } catch (err) {
            setLoading(false)
        }finally{
            setLoading(false)
        }
    };


    return (
        <div className="navbar-container">
            <div className='navbar'>
                <div className="menu">
                    <div className="menu-bars"
                        onClick={toogleMenu}
                    >
                        <FaBars />
                    </div>
                    <div className="menu-items-container">
                        <div className="menu-items">
                            <div className="menu-box ">
                                <NavLink to="/">
                                    <div className="menu-item">
                                        <FaHome />
                                    </div>
                                </NavLink>
                            </div>
                            <div className="menu-box">
                                <NavLink to="/chats/">
                                    <div className="menu-item">
                                        <FaRegEnvelope />
                                    </div>
                                </NavLink>
                            </div>
                            <div className="menu-box">
                                <NavLink to="/organizations/">
                                    <div className="menu-item">
                                        <VscOrganization />
                                    </div>
                                </NavLink>
                            </div>
                            <div className="menu-box">
                                <NavLink to="/b/">
                                    <div className="menu-item">
                                        <BiStoreAlt />
                                    </div>
                                </NavLink>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="icons-bar">
                    <div className="search">
                        <Link to="/search">
                            <div className="menu-item search">
                                <FaSearch />
                            </div>
                        </Link>
                    </div>
                    <div className="notifications">
                        <Link to="/notifications">
                            <div className="menu-item">
                                <FaBell />
                            </div>
                        </Link>
                    </div>
                </div>
                <div className="profiles">
                    <Link to="/profile/" >
                        <div className="profile-img">
                            <img
                                className="profile-pic"
                                src={user?.user?.profilePic || user?.profilePic || profilePic}
                                alt="onnize"
                            />
                        </div>
                    </Link>
                    <Link to="/">
                        <div className="onnize-logo">
                            <img src={logo} alt="onnize" className="logo-img" />
                        </div>
                    </Link>
                </div>
            </div>

            {/* side menu */}
            <div className={sideMenu ? "menu-opened" : "menu-closed"}>
                <button onClick={closeMenu} className="close-side-menu-btn">
                    <FaTimes />
                </button>
                <h1 className="side-menu-title">ONNIZE</h1>
                <div className="side-menu-items">
                    <div className="side-menu-list">
                        <h3 className="side-menu-title">My Businesses</h3>
                        <div className="side-menu-items-list">
                            <Link to={'/events'} onClick={() => setSideMenu(false)}>Events</Link>
                            <Link to={'/b/mystores'} onClick={() => setSideMenu(false)}>Businesses</Link>
                            <Link to={'/carts'} onClick={() => setSideMenu(false)}>Carts</Link>
                            <Link to={'/orders'} onClick={() => setSideMenu(false)}>Orders</Link>
                            <Link to={'/invoices'} onClick={() => setSideMenu(false)}>Invoices</Link>
                            <Link to={'/bookmarks'} onClick={() => setSideMenu(false)}>Bookmarks</Link>
                        </div>
                    </div>
                    <div className="side-menu-footer">
                        <Link to="/settings" onClick={() => setSideMenu(false)}>Settings</Link>
                        <Link to="/help" onClick={() => setSideMenu(false)}>Help</Link>
                        <Link to="/language" onClick={() => setSideMenu(false)}>Language</Link>
                        <Link to="/policy" onClick={() => setSideMenu(false)}>Privacy Policy</Link>
                        <a
                            href="https://company.onnize.com"
                            onClick={() => setSideMenu(false)}
                            target="_blank"
                            rel="noreferrer"
                        >
                            About Onnize
                        </a>
                        <button onClick={handleLogOut}>{loading?"Loading...":"logout"}</button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Navbar